/**
 * Up/down delta pill. `pct` is a signed number, or null = "new" (no baseline).
 * By default an increase is green (good). For metrics where up is bad — issues
 * opened, consumption — pass `invert` so a rise reads red.
 *   <DeltaBadge pct={12.5} />            ↑ 12.5%   (green)
 *   <DeltaBadge pct={-8} invert />       ↓ 8%      (green — fewer is good)
 */
const GOOD = '#7BD4A8';
const BAD = '#E63B7A';

export const DeltaBadge = ({ pct, invert = false }) => {
  if (pct == null) {
    return (
      <span class="inline-flex items-center rounded-sm bg-bg-base px-1.5 py-0.5 font-mono text-[11px] font-medium text-text-muted">
        new
      </span>
    );
  }
  const up = pct > 0;
  const flat = pct === 0;
  const good = flat ? null : invert ? !up : up;
  const color = good == null ? '#8A8278' : good ? GOOD : BAD;
  const arrow = flat ? '→' : up ? '↑' : '↓';
  return (
    <span
      class="inline-flex items-center gap-0.5 rounded-sm px-1.5 py-0.5 font-mono text-[11px] font-medium"
      style={{ color, background: 'rgba(0,0,0,0.18)' }}
    >
      {arrow} {Math.abs(pct)}%
    </span>
  );
};
